import './TopNav.less';
import React from 'react';
import ProfileBlock from "./profile-block/ProfileBlock";
import LogoBlock from "./logo-block/LogoBlock";
import RegisterBlock from "./register-block/RegisterBlock";
import AuthContext from "../../contexts/auth/AuthContext";
import Breadcrumb from "./breadcrumb/Breadcrumb";
import MediaQueryDisplay from "../../components/media-query-display/MediaQueryDisplay";
import screenSizeQueries from "../../styles/screenSizeQueries";


export default function TopNav({}) {

    return <div className="top-nav">
        <AuthContext.Consumer>
            {
                ({user}) => <>
                    <div className="left">
                        <LogoBlock/>
                        <MediaQueryDisplay query={screenSizeQueries.desktop}>
                            <Breadcrumb/>
                        </MediaQueryDisplay>
                    </div>
                    <div className="right">
                        {
                            user
                                ? <ProfileBlock/>
                                : <RegisterBlock/>
                        }
                    </div>
                </>
            }
        </AuthContext.Consumer>
    </div>;
}
